/**************************************************************
 *                                                            *
 *                 THIS HAS BEEN REMOVED                      *
 *                AND IS NEVER COMING BACK                    *
 *                                                            *
 **************************************************************/

import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from "@angular/core";
import {Table} from "primeng/table";
import {read, utils} from "xlsx";
import {IdentityAccountsService} from "../../../../shared/core-ndms/services/identity-accounts.service";
import {NdmsAuthService} from "../../../../shared/core-ndms/services/ndms-auth.service";
import {DatetimeService} from "../../../../../../projects/jpats/app/shared/services/datetime.service";
import {ToastService} from "../../../../../../projects/shared/core/services/toast.service";


@Component({
  selector: 'ndms-users-import',
  templateUrl: './users-import.component.html',
  styleUrls: ['./users-import.component.scss']
})
export class UsersImportComponent implements OnInit {
  @ViewChild('inputFile')
  inputFile: ElementRef;
  @Input() public close = new EventEmitter();
  message: string="";
  results: any[]= [];
  initCols: any[] = [
    { field: 'UserName', header: 'UserName', width:'10%', desc: 'The User name' },
    { field: 'FirstName', header: 'FirstName', width:'7%', desc:'The First name' },
    { field: 'LastName', header: 'LastName', width:'7%',desc:'The last name' },
    { field: 'ExternalKey', header: 'ExternalKey', width:'5%',desc:'External Key' },
    { field: 'Attributes', header: 'Attributes', width:'5%',desc: 'JSON for custom attributes' },

  ];
  constructor(private identityAccounts: IdentityAccountsService, private ndmsAuthService: NdmsAuthService, private toastService: ToastService){

  }
  cols: any[] = [];
  allApps:any[] = [];
  ngOnInit(): void {
    this.ndmsAuthService.getAllApps().subscribe((appdata:any)=>{
      this.allApps =appdata.model;
    });
  }
  arrayBuffer:any;
  file:File;
  filetoupload:any;
  incomingfile(event)
  {
    this.file= event.target.files[0];
  }
  uploadFile(){

    let users = this.filetoupload.map((user)=>{
      return user;
    });
    this.identityAccounts.upload({userModels:users,applications:this.apps}).subscribe((res)=>{
      this.filetoupload = undefined;
      this.inputFile.nativeElement.value = '';
      this.arrayBuffer = undefined;
      this.file = undefined;
      this.results = [];
      this.cols = [];
      if(this.close)
        this.close.emit({success:true});


    });
  }
  closeWindow(){
    this.close.emit({});
  }
  apps:any[] = [];
  setApp(event){
    let app = this.allApps.find(i=>i.key === event.target.value);
    this.apps =[app];
  }
  /*
   { field: 'UserName', header: 'UserName', width:'10%', desc: 'The User name' },
    { field: 'FirstName', header: 'FirstName', width:'7%', desc:'The First name' },
    { field: 'LastName', header: 'LastName', width:'7%',desc:'The last name' },
    { field: 'ExternalKey', header: 'ExternalKey', width:'5%',desc:'External Key' },
    { field: 'Attributes', header: 'Attributes', width:'5%',desc: 'JSON for custom attributes' },
   */
  readErrors: number = 0;
  readFile(){
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.readErrors = 0;
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = [];
      for(let i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);

      let bstr = arr.join("");
      let workbook = read(bstr, {type:"binary"});
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];

      this.filetoupload =utils.sheet_to_json(worksheet,{raw:false});
      this.results = this.filetoupload.map((user)=>{
        let userName = user.UserName;
        let firstName = user.FirstName;
        let lastName = user.LastName;
        let externalKey = user.ExternalKey;
        let attributes = user.Attributes;
        if (!userName ) {
          this.readErrors++;
        }
        if (!firstName) {
          this.readErrors++;
        }
        if (!lastName) {
          this.readErrors++;
        }

        return {
          UserName: (userName ?   `<span class='alert-success'>${userName}</span>` : `<span class='alert-danger'>${userName} :Missing</span>`),
          FirstName: (firstName ? `<span class='alert-success'>${firstName}</span>` : `<span class='alert-danger'>${firstName} :Missing</span>`),
          LastName: (lastName ?   `<span class='alert-success'>${lastName}</span>` : `<span class='alert-danger'>${lastName} :Missing</span>`),
          ExternalKey: `<span class='alert-success'>${externalKey}</span>`,
          Attributes: `<span class='alert-success'>${attributes}</span>`
        };
      });
      this.cols = [];
      let objcols = this.get_header_row(worksheet);
      this.initCols.forEach((col)=>{
        let ncol = Object.assign({},col,{htmlClass: objcols.find(i => col.field === i) ? "" :"alert-danger"});
        this.cols.push(ncol);
      });
      objcols.forEach((col)=>{
        if(!this.cols.find((i) => i.field === col))
          this.cols.push({ field: col, htmlClass:'alert-danger', header: col});
      });
      /*this.cols = Object.keys(this.results[0]).map((res)=>{
        return { field: res, header: res };
      });*/
      console.log(this.filetoupload);
    };
    fileReader.readAsArrayBuffer(this.file);
  }
  get_header_row(sheet) {
    let headers:any[] = [];
    let range = utils.decode_range(sheet['!ref']);
    let C, R = range.s.r; /* start in the first row */
    /* walk every column in the range */
    for(C = range.s.c; C <= range.e.c; ++C) {
      let cell = sheet[utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
      let hdr = "UNKNOWN " + (C || ""); // <-- replace with your desired default
      if(cell && cell.t) hdr = utils.format_cell(cell) || "";
      headers.push(hdr);
    }
    return headers;
  }
}
